import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import useRouteLeaveGuard from 'Hooks/useRouteLeaveGuard'
import {
  Modal,
  ModalBody,
  ModalHead,
  ModalFoot,
  Button
} from 'mailup-web-components'

import { beePluginState, editorState } from '../recoil/state/editor'

export const ModalConfirmLeave = () => {
  const intl = useIntl()
  const { dirty, saved } = useRecoilValue(editorState)
  const [prompt, allow, deny, dest] = useRouteLeaveGuard(!dirty || saved)
  const { instance: beePluginInstance } = useRecoilValue(beePluginState)
  const setEditorState = useSetRecoilState(editorState)

  const handleConfirm = () => {
    if (dest.startsWith('/messages/email/save-row/')) {
      setEditorState(prev => ({
        ...prev,
        afterSaveCallback: ({ id }) => {
          allow()
        },
        action: undefined
      }))
      beePluginInstance.save()
    } else {
      allow()
    }
  }

  return (
    <Modal show={prompt} showClose closeOnOverlayClick={false} onClose={deny}>
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.Bee.ConfirmExitTitle'
        })}
      />
      <ModalBody>
        {intl.formatMessage({
          id: 'Load.Bee.ConfirmExitDescription'
        })}
      </ModalBody>
      <ModalFoot>
        {dest.startsWith('/messages/email/save-row/') ? (
          <>
            <Button onClick={allow} kind='secondary'>
              {intl.formatMessage({
                id: 'Load.SaveRow.ExitModalNoSaveProceedCta'
              })}
            </Button>
            <Button onClick={handleConfirm} kind='primary'>
              {intl.formatMessage({
                id: 'Load.SaveRow.ExitModalSaveProceedCta'
              })}
            </Button>
          </>
        ) : (
          <>
            <Button onClick={deny} kind='secondary'>
              {intl.formatMessage({
                id: 'Load.MailupCommon.Cancel'
              })}
            </Button>
            <Button onClick={handleConfirm} kind='primary'>
              {intl.formatMessage({
                id: 'Load.Common.Exit'
              })}
            </Button>
          </>
        )}
      </ModalFoot>
    </Modal>
  )
}
